module.exports = __webpack_public_path__ + "img/03.007d865f.jpg";